import ReactDOM from "react-dom/client";
import { HashRouter } from "react-router-dom";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import MainRouter from "./MainRouter";

const root = ReactDOM.createRoot(document.getElementById("custom_react_components") as HTMLElement);
root.render(
    <HashRouter>
        <MainRouter />
    </HashRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
